import { makeVar } from '@apollo/client';

export const isStaleSessionModalOpenVar = makeVar<boolean>(false);
